import { createAction, props } from '@ngrx/store';
import { IDjangoErrors } from '../../../../shared/models/DjangoErrors';
import {
  ICrossFieldRule,
  IRuleOperation,
  IRuleParamDefinition,
  IRuleTypeCatalogEntry,
  IRuleTypeDefinition,
  IValidatorRule,
} from '../../models/validation-rule';

enum ValidationRulesApiActionTypes {
  loadFieldRulesSuccess = '[Validation Rules API] Load Field Rules Success',
  loadFieldRulesError = '[Validation Rules API] Load Field Rules Failure',

  loadCrossFieldRulesSuccess = '[Validation Rules API] Load Cross-Field Rules Success',
  loadCrossFieldRulesError = '[Validation Rules API] Load Cross-Field Rules Failure',

  loadCatalogSuccess = '[Validation Rules API] Load Catalog Success',
  loadCatalogError = '[Validation Rules API] Load Catalog Failure',

  createFieldRuleSuccess = '[Validation Rules API] Create Field Rule Success',
  createFieldRuleError = '[Validation Rules API] Create Field Rule Failure',
  patchFieldRuleSuccess = '[Validation Rules API] Patch Field Rule Success',
  patchFieldRuleError = '[Validation Rules API] Patch Field Rule Failure',
  deleteFieldRuleSuccess = '[Validation Rules API] Delete Field Rule Success',
  deleteFieldRuleError = '[Validation Rules API] Delete Field Rule Failure',

  createCrossFieldRuleSuccess = '[Validation Rules API] Create Cross-Field Rule Success',
  createCrossFieldRuleError = '[Validation Rules API] Create Cross-Field Rule Failure',
  patchCrossFieldRuleSuccess = '[Validation Rules API] Patch Cross-Field Rule Success',
  patchCrossFieldRuleError = '[Validation Rules API] Patch Cross-Field Rule Failure',
  deleteCrossFieldRuleSuccess = '[Validation Rules API] Delete Cross-Field Rule Success',
  deleteCrossFieldRuleError = '[Validation Rules API] Delete Cross-Field Rule Failure',

  // Configurable catalog action types
  loadOperationsSuccess = '[Validation Rules API] Load Operations Success',
  loadOperationsError = '[Validation Rules API] Load Operations Failure',

  loadRuleTypeDefsSuccess = '[Validation Rules API] Load Rule Type Definitions Success',
  loadRuleTypeDefsError = '[Validation Rules API] Load Rule Type Definitions Failure',

  createRuleTypeDefSuccess = '[Validation Rules API] Create Rule Type Definition Success',
  createRuleTypeDefError = '[Validation Rules API] Create Rule Type Definition Failure',
  patchRuleTypeDefSuccess = '[Validation Rules API] Patch Rule Type Definition Success',
  patchRuleTypeDefError = '[Validation Rules API] Patch Rule Type Definition Failure',
  deleteRuleTypeDefSuccess = '[Validation Rules API] Delete Rule Type Definition Success',
  deleteRuleTypeDefError = '[Validation Rules API] Delete Rule Type Definition Failure',

  createParamDefSuccess = '[Validation Rules API] Create Param Definition Success',
  createParamDefError = '[Validation Rules API] Create Param Definition Failure',
  patchParamDefSuccess = '[Validation Rules API] Patch Param Definition Success',
  patchParamDefError = '[Validation Rules API] Patch Param Definition Failure',
  deleteParamDefSuccess = '[Validation Rules API] Delete Param Definition Success',
  deleteParamDefError = '[Validation Rules API] Delete Param Definition Failure',
}

// ---- loads -----------------------------------------------------------

export const loadFieldRulesSuccess = createAction(
  ValidationRulesApiActionTypes.loadFieldRulesSuccess,
  props<{ payload: IValidatorRule[] }>(),
);
export const loadFieldRulesError = createAction(
  ValidationRulesApiActionTypes.loadFieldRulesError,
  props<{ errors: IDjangoErrors }>(),
);

export const loadCrossFieldRulesSuccess = createAction(
  ValidationRulesApiActionTypes.loadCrossFieldRulesSuccess,
  props<{ payload: ICrossFieldRule[] }>(),
);
export const loadCrossFieldRulesError = createAction(
  ValidationRulesApiActionTypes.loadCrossFieldRulesError,
  props<{ errors: IDjangoErrors }>(),
);

export const loadCatalogSuccess = createAction(
  ValidationRulesApiActionTypes.loadCatalogSuccess,
  props<{ payload: IRuleTypeCatalogEntry[] }>(),
);
export const loadCatalogError = createAction(
  ValidationRulesApiActionTypes.loadCatalogError,
  props<{ errors: IDjangoErrors }>(),
);

// ---- field-rule mutations -------------------------------------------

export const createFieldRuleSuccess = createAction(
  ValidationRulesApiActionTypes.createFieldRuleSuccess,
  props<{ payload: IValidatorRule }>(),
);
export const createFieldRuleError = createAction(
  ValidationRulesApiActionTypes.createFieldRuleError,
  props<{ errors: IDjangoErrors }>(),
);

export const patchFieldRuleSuccess = createAction(
  ValidationRulesApiActionTypes.patchFieldRuleSuccess,
  props<{ payload: IValidatorRule }>(),
);
export const patchFieldRuleError = createAction(
  ValidationRulesApiActionTypes.patchFieldRuleError,
  props<{ errors: IDjangoErrors }>(),
);

export const deleteFieldRuleSuccess = createAction(
  ValidationRulesApiActionTypes.deleteFieldRuleSuccess,
  props<{ id: number }>(),
);
export const deleteFieldRuleError = createAction(
  ValidationRulesApiActionTypes.deleteFieldRuleError,
  props<{ errors: IDjangoErrors }>(),
);

// ---- cross-field mutations -----------------------------------------

export const createCrossFieldRuleSuccess = createAction(
  ValidationRulesApiActionTypes.createCrossFieldRuleSuccess,
  props<{ payload: ICrossFieldRule }>(),
);
export const createCrossFieldRuleError = createAction(
  ValidationRulesApiActionTypes.createCrossFieldRuleError,
  props<{ errors: IDjangoErrors }>(),
);

export const patchCrossFieldRuleSuccess = createAction(
  ValidationRulesApiActionTypes.patchCrossFieldRuleSuccess,
  props<{ payload: ICrossFieldRule }>(),
);
export const patchCrossFieldRuleError = createAction(
  ValidationRulesApiActionTypes.patchCrossFieldRuleError,
  props<{ errors: IDjangoErrors }>(),
);

export const deleteCrossFieldRuleSuccess = createAction(
  ValidationRulesApiActionTypes.deleteCrossFieldRuleSuccess,
  props<{ id: number }>(),
);
export const deleteCrossFieldRuleError = createAction(
  ValidationRulesApiActionTypes.deleteCrossFieldRuleError,
  props<{ errors: IDjangoErrors }>(),
);

// ---- Configurable catalog --------------------------------------------

export const loadOperationsSuccess = createAction(
  ValidationRulesApiActionTypes.loadOperationsSuccess,
  props<{ payload: IRuleOperation[] }>(),
);
export const loadOperationsError = createAction(
  ValidationRulesApiActionTypes.loadOperationsError,
  props<{ errors: IDjangoErrors }>(),
);

export const loadRuleTypeDefsSuccess = createAction(
  ValidationRulesApiActionTypes.loadRuleTypeDefsSuccess,
  props<{ payload: IRuleTypeDefinition[] }>(),
);
export const loadRuleTypeDefsError = createAction(
  ValidationRulesApiActionTypes.loadRuleTypeDefsError,
  props<{ errors: IDjangoErrors }>(),
);

export const createRuleTypeDefSuccess = createAction(
  ValidationRulesApiActionTypes.createRuleTypeDefSuccess,
  props<{ payload: IRuleTypeDefinition }>(),
);
export const createRuleTypeDefError = createAction(
  ValidationRulesApiActionTypes.createRuleTypeDefError,
  props<{ errors: IDjangoErrors }>(),
);

export const patchRuleTypeDefSuccess = createAction(
  ValidationRulesApiActionTypes.patchRuleTypeDefSuccess,
  props<{ payload: IRuleTypeDefinition }>(),
);
export const patchRuleTypeDefError = createAction(
  ValidationRulesApiActionTypes.patchRuleTypeDefError,
  props<{ errors: IDjangoErrors }>(),
);

export const deleteRuleTypeDefSuccess = createAction(
  ValidationRulesApiActionTypes.deleteRuleTypeDefSuccess,
  props<{ id: number }>(),
);
export const deleteRuleTypeDefError = createAction(
  ValidationRulesApiActionTypes.deleteRuleTypeDefError,
  props<{ errors: IDjangoErrors }>(),
);

export const createParamDefSuccess = createAction(
  ValidationRulesApiActionTypes.createParamDefSuccess,
  props<{ payload: IRuleParamDefinition }>(),
);
export const createParamDefError = createAction(
  ValidationRulesApiActionTypes.createParamDefError,
  props<{ errors: IDjangoErrors }>(),
);

export const patchParamDefSuccess = createAction(
  ValidationRulesApiActionTypes.patchParamDefSuccess,
  props<{ payload: IRuleParamDefinition }>(),
);
export const patchParamDefError = createAction(
  ValidationRulesApiActionTypes.patchParamDefError,
  props<{ errors: IDjangoErrors }>(),
);

export const deleteParamDefSuccess = createAction(
  ValidationRulesApiActionTypes.deleteParamDefSuccess,
  props<{ id: number }>(),
);
export const deleteParamDefError = createAction(
  ValidationRulesApiActionTypes.deleteParamDefError,
  props<{ errors: IDjangoErrors }>(),
);
